<template>
    <b-form-select v-model="selectedCity" id="city" :plain="true" :options="this.cityDDL" @change="onCityChange"></b-form-select>
</template>

<script>

import axios from "axios";

export default {
  name: "DdlCityComponent",
  props: {
    countryId: String,
    stateId: String,
    currentCityId: String
  },
  data() {
    return {
        cityDDL: [],
        selectedCity: this.currentCityId
    }
  },
  watch: {
    stateId: {
      immediate: true,
      handler(newValue) {
        this.getCity(newValue);
      },
    },
    currentCityId: {
      immediate: true,
      handler(newValue) {
        this.selectedCity = newValue;
      },
    },
  },
  methods: {
    async getCity(stateId) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        const storageName = this.$store.state.config.storageName
        
        var recoveredCity = localStorage.getItem(storageName + "_CITY_" + stateId)

        if(!recoveredCity) {
            await axios.get(
              this.$store.state.ws_url + "/city/ddl?countryId=" + s.countryId + "&stateId=" + stateId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.cityDDL = resp.data.obj;
                localStorage.setItem(storageName + "_CITY_" + stateId, JSON.stringify(resp.data.obj))
            })
            .catch(function(error) {
                console.log(error);
            });
        }
        else {
            s.cityDDL = JSON.parse(recoveredCity)            
        }
                
    },
    onCityChange() {
      this.$emit('city-selected', this.selectedCity);
    }
   
  }
  
};

</script>
